import { Directive, HostListener, ElementRef } from "@angular/core";

@Directive({
    selector: "[appInputUpperCase]",
})
export class InputUpperCaseDirective {
    constructor(private elementRef: ElementRef) {}

    // Listen for the input event to also handle copy and paste.
    @HostListener("input")
    onInput() {
        const inputElement = this.elementRef.nativeElement as HTMLInputElement;
        inputElement.value = inputElement.value.toUpperCase();
    }
}
